import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive, RouterLinkWithHref } from '@angular/router';

import { DesignSystemModule } from '@compeople-shared/design-system-angular';
import { TranslocoModule } from '@jsverse/transloco';

import {
  ChdAccordion,
  ChdButton,
  ChdCheckbox,
  ChdDialog,
  ChdErrorMessage,
  ChdExpansionPanel,
  ChdIconButton,
  ChdProgressSpinner,
  ChdSlideToggle,
  ChdTable,
  ChdText,
  ChdTextInput,
} from '@cp-produkte/cruise-hospitality-design';
import { PermissionModule } from '@permission';
import { PipesModule, DiagramPipesModule, GetSlotPipe } from '@pipe';

import { AlertComponent } from './alert/alert.component';
import { AutocompleteSearchComponent } from './autocomplete-search/autocomplete-search.component';
import { AutocompleteTemplateComponent } from './autocomplete-search/autocomplete-template/autocomplete-template.component';
import { BarChartCapacityComponent } from './bar-chart-capacity/bar-chart-capacity.component';
import { BarChartComponent } from './bar-chart/bar-chart.component';
import { BookingStatusComponent } from './booking-status/booking-status.component';
import { CancellationStatusComponent } from './cancellation-status/cancellation-status.component';
import { CardComponent } from './card/card.component';
import { CompanionsSpaListComponent, FilledCompanionsPipe } from './companions/companions-spa-list.component';
import { DetailAreaComponent } from './detail-area/detail-area.component';
import { ErrorAlertComponent } from './error-alert/error-alert.component';
import { NavigationComponent } from './navigation/navigation.component';
import { NumberInputComponent } from './number-input/number-input.component';
import { PageContainerComponent } from './page-container/page-container.component';
import { PageComponent } from './page/page.component';
import { ReportBarChartCapacityComponent } from './report-bar-chart-capacity/report-bar-chart-capacity.component';
import { ReportBarChartComponent } from './report-bar-chart/report-bar-chart.component';
import { SettingsMenuComponent } from './settings-menu/settings-menu.component';
import { SpaButtonComponent } from './spa-button/spa-button.component';
import { SpaIconComponent } from './spa-icon/spa-icon.component';
import { SpaListTemplateComponent } from './spa-list/spa-list-template/spa-list-template.component';
import { SpaListComponent } from './spa-list/spa-list.component';
import { SpaColTplComponent } from './spa-table/spa-col-template/spa-col-tpl.component';
import { SpaTableComponent } from './spa-table/spa-table.component';
import { TabsComponent } from './tabs/tabs.component';
import { TimeInputComponent } from './time-input/time-input.component';

const cmps = [
  AlertComponent,
  AutocompleteSearchComponent,
  AutocompleteTemplateComponent,
  BarChartCapacityComponent,
  BarChartComponent,
  BookingStatusComponent,
  CancellationStatusComponent,
  CardComponent,
  CompanionsSpaListComponent,
  DetailAreaComponent,
  ErrorAlertComponent,
  NavigationComponent,
  NumberInputComponent,
  PageComponent,
  PageContainerComponent,
  ReportBarChartCapacityComponent,
  ReportBarChartComponent,
  SettingsMenuComponent,
  SpaButtonComponent,
  SpaColTplComponent,
  SpaIconComponent,
  SpaListComponent,
  SpaListTemplateComponent,
  SpaTableComponent,
  TabsComponent,
  TimeInputComponent,
];

const imps = [
  ChdAccordion,
  ChdButton,
  ChdCheckbox,
  ChdDialog,
  ChdErrorMessage,
  ChdExpansionPanel,
  ChdIconButton,
  ChdProgressSpinner,
  ChdSlideToggle,
  ChdTable,
  ChdText,
  ChdTextInput,
  CommonModule,
  DesignSystemModule,
  DiagramPipesModule,
  FilledCompanionsPipe,
  FormsModule,
  GetSlotPipe,
  OverlayModule,
  PermissionModule,
  PipesModule,
  ReactiveFormsModule,
  RouterLink,
  RouterLinkActive,
  RouterLinkWithHref,
  TranslocoModule,
];

@NgModule({
  declarations: [...cmps],
  imports: [...imps],
  exports: [...cmps],
})
export class ComponentsModule {}
